import { MenuItem } from "@app/types";
import { MouseEvent } from "react";
import { NavLink } from "react-router-dom";

interface MenuItemProps extends MenuItem {
  className?: string;

  labelClassName?: string;

  onClick?: (e: MouseEvent<HTMLAnchorElement>) => void;
}

function MenuLinkItem({
  linkTo,
  label,
  icon,
  className = "",
  labelClassName = "",
  linkOther,
  onClick,
}: MenuItemProps) {
  return (
    <NavLink
      target={linkOther ? "_blank" : undefined}
      to={linkOther ? linkOther : linkTo}
      onClick={onClick}
      className={({ isActive }) => {
        let classNames = `h-14 px-5 flex items-center rounded-xl hover:bg-[#4559be] [&_.label]:hover:text-white [&_.fill]:hover:fill-white [&_.stroke]:hover:stroke-white ${className} `;

        if (isActive) {
          classNames +=
            "text-white bg-color-primary [&_.fill]:fill-white [&_.stroke]:stroke-white";
        }

        return classNames;
      }}
    >
      <div className="mr-4">{icon}</div>
      <div className={`label tracking-[0.024px] ${labelClassName}`}>
        {label}
      </div>
    </NavLink>
  );
}

export default MenuLinkItem;
